import queryString from 'query-string';
import { IPagingInfo, ISurveyFilters } from './surveys';
import API from '../api/api';
import { ApiRoutes } from '../constans/api';
import {
  ETeamComparisonRating,
  ETeamComparisonRepresentativeness,
  ETeamComparisonRiskLevel,
} from '../constans/report';
import { filterEmptyFilters } from '../helpers/helpers';

export interface ITeam {
  id: string;
  name: string;
}

export interface IResponsiveness {
  responseCount: number;
  participantCount: number;
  responseRate: number;
  representativeness: ETeamComparisonRepresentativeness;
}

export interface IRisk {
  score: number;
  level: ETeamComparisonRiskLevel;
}

export interface IKpi {
  score: number;
  rating: ETeamComparisonRating;
  target?: number;
}

export interface ICategory {
  code: string;
  title: string;
}

export interface IResult {
  score: number;
  rating: ETeamComparisonRating;
}

export interface IWorkEnvironment {
  category: ICategory;
  result: IResult;
}

export interface ITeamComparisonItem {
  reportId?: number;
  team: ITeam;
  responsiveness: IResponsiveness;
  risk?: IRisk;
  kpi?: IKpi;
  workEnvironment: IWorkEnvironment[];
}

export interface IGetTeamsComparisonResponse {
  items: ITeamComparisonItem[];
  pagingInfo: IPagingInfo;
}

export interface IGroupComparisonFilters {
  pageNo?: string | null;
  perPage?: string | null;
  scope?: string | null;
  sortOrder?: string | null;
  teamName?: string | null;
  risk?: string[] | null;
  teamId?: string[] | null;
}

export const getTeamsComparisonRequest = async (
  reportId: string,
  filters: IGroupComparisonFilters
): Promise<IGetTeamsComparisonResponse> => {
  const filteredFilters = filterEmptyFilters(filters as unknown as ISurveyFilters);
  const { teamsResultsComparison, reports } = ApiRoutes;
  const { data } = await API.get(`${reports}${reportId}${teamsResultsComparison}`, {
    params: filteredFilters,
    paramsSerializer: (params: Record<string, unknown>) => {
      return queryString.stringify(params, { arrayFormat: 'separator' });
    },
  });
  return data;
};
